import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../app/app-env';
import {frefFromRef} from '../../lib/react/higher-order-components';
import {OEVersion} from '../../react-oe/oe-version';
import {OEViewType} from '../../lib/oe-types';
import OENotification from '../../lib/notification/oe-notification';
import {OEImplantcastRegisterNoticeController} from '../custom/implantcast/oe-implantcast-register-notice';

export function OECustomExtViewFactory(props) {
    let {fref, ...rest} = props;

    const openFn = (sender, isOpen) => {
        if(!props.appComponent || !props.appComponent.uiLayer) return;
        props.appComponent.uiLayer.notificationCenter.post(OENotification.viewOpenStateChanged, {
            type:   OEViewType.customExt,
            isOpen: isOpen,
            sender: sender
        });
    };

    /*
    if(props.version === OEVersion.implantcast) {
        return <OEImplantcastRegisterNoticeController moduleId={props.moduleId} ref={fref} onOpenStateChanged={openFn}/>
    }
    */

    return null;
}

OECustomExtViewFactory.defaultProps = {
    moduleId:       ''
};

OECustomExtViewFactory.propTypes = {
    moduleId:       PropTypes.string
};

//
export default frefFromRef(connectAppEnv((env) => { return {
    version:        env.config.version,
    target:         env.config.target,
    flags:          env.config.module.flags,
    appComponent:   env.component,
}})(OECustomExtViewFactory));